/**
 * CraneSoftwares shared UI — BrandLogo
 * Platform brand only. Do not use for tenant/company logos.
 *
 * Official asset: https://cranesoftwares.com/cranelogo.png
 * Canonical copy: apps/shared-ui/assets/branding/cranesoftwares-logo.png
 *
 * Collapsed / mark mode scales the full official logo (contain).
 * Do not invent a cropped mark — no official mark asset exists.
 */
import React from "react";

export function BrandLogo({
  src,
  variant = "full", // full | mark
  size = "md", // sm | md | lg
  collapsed = false,
  className = "",
  alt = "CraneSoftwares",
  decorative = false,
  asLink = false,
  href = "/",
  title = "CraneSoftwares home",
  showWordmark = false,
}) {
  const heights = { sm: 28, md: 40, lg: 56 };
  const h = heights[size] || heights.md;
  const showMarkOnly = collapsed || variant === "mark";

  const img = (
    <img
      src={src}
      alt={decorative ? "" : alt}
      aria-hidden={decorative ? "true" : undefined}
      className={`crane-brand-logo ${showMarkOnly ? "crane-brand-logo--mark" : "crane-brand-logo--full"} ${className}`}
      style={{
        height: h,
        width: "auto",
        maxWidth: showMarkOnly ? Math.max(h + 8, 40) : 220,
        objectFit: "contain",
        objectPosition: "left center",
        display: "block",
      }}
      draggable={false}
    />
  );

  const content =
    showWordmark && !showMarkOnly ? (
      <span className="crane-brand-logo-link" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        {img}
        <span className="crane-brand-wordmark">
          <span className="crane-brand-wordmark__title">CraneSoftwares</span>
          <span className="crane-brand-wordmark__subtitle">Enterprise</span>
        </span>
      </span>
    ) : (
      img
    );

  if (asLink) {
    return (
      <a href={href} className="crane-brand-logo-link" title={title} aria-label={title}>
        {content}
      </a>
    );
  }
  return content;
}

export default BrandLogo;
